import { render, staticRenderFns } from "./single-sample-message.vue?vue&type=template&id=d7cbc59c&"
import script from "./single-sample-message.vue?vue&type=script&lang=js&"
export * from "./single-sample-message.vue?vue&type=script&lang=js&"
import style0 from "./single-sample-message.vue?vue&type=style&index=0&id=d7cbc59c&prod&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports